import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import "bootstrap/dist/css/bootstrap.min.css"
import styled from "@emotion/styled"
import SplitText from "react-pose-text"

const charPoses = {
  exit: { opacity: 0, y: 20 },
  enter: {
    opacity: 1,
    y: 0,
    delay: ({ charIndex }) => charIndex * 5,
  },
}

const Heading = styled.h2`
  margin-top: 60px;
  margin-bottom: 30px;
  color: darkorange;
`

const ColourLink = styled.a`
  color: lightcoral;
`

const IndexPage = () => (
  <Layout>
    <SEO title="About" />
    <Heading>
      <SplitText initialPose="exit" pose="enter" charPoses={charPoses}>
        About this site
      </SplitText>
    </Heading>
    <p>
      This site was built as a showcase for many of the tools that we have built
      or administer. It was built on <ColourLink href="https://reactjs.org">React</ColourLink>,{" "}
      <ColourLink href="https://www.gatsbyjs.org">Gatsby</ColourLink>, and uses <ColourLink href="https://www.contentful.com/content-infrastructure/">Contentful</ColourLink> to power
      content.
    </p>
    <p>
      We are a group of front and back-end web developers, system
      administrators, and support staff in the{" "}
      Learning and Technology Division of the new{" "}
      <ColourLink href="https://www.sfu.ca/cee.html">Centre for Educational Excellence</ColourLink> at Simon Fraser University.{" "}
    </p>
  </Layout>
)

export default IndexPage
